export const dirtyValues = (formData: object, defaultObject: object): object => {
  const formDataClone = { ...formData };
  deleteDefaults(formDataClone, defaultObject);

  const result = clearEmpties(formDataClone);

  return result;
};

const deleteDefaults = (dirtyObject: any, defaultObject: any) => {
  Object.keys(defaultObject).forEach((key) => {
    if (typeof dirtyObject[key] === 'object' && !Array.isArray(dirtyObject[key])) {
      deleteDefaults(dirtyObject[key], defaultObject[key]);
    } else {
      if (dirtyObject[key] == defaultObject[key]) {
        delete dirtyObject[key];
      }
    }
  });
};

const clearEmpties = (object: any) => {
  for (const key in object) {
    if (!object[key] || typeof object[key] !== 'object') {
      continue;
    }
    clearEmpties(object[key]);
    if (Object.keys(object[key]).length === 0) {
      delete object[key];
    }
  }
  return object;
};
